import {turquoise300} from '@/styles/palette';
import {Box, Typography} from '@mui/material';

export const BlockQuote = ({text}: {text?: string}) => {
  return (
    <Box
      component="blockquote"
      sx={{
        background: turquoise300,
        borderRadius: '16px',
        padding: '16px',
        margin: 'unset',
        marginBottom: 4,
        lineHeight: '1.5',
      }}>
      <Typography variant="body1" component="p">
        {`"${
          text ||
          "My son has been using Ello for a few weeks now and I couldn't be happier with this reading app. It's truly one of a kind. It has motivated my son to read more and it make it easy for him to do on his own!"
        }"`}
      </Typography>
    </Box>
  );
};
